.section {
  border-bottom: 1px solid rgba(8, 18, 12, 0.12);
  padding-bottom: var(--token-space-md);
  margin-bottom: 0;
}

/* Match the other section headings on the Number page. */
.section h2 {
  font-family: var(--token-font-display);
  margin: 0 0 var(--token-space-md);
  font-size: 33px;
  color: var(--token-text-primary);
}

.row {
  display: flex;
  gap: var(--token-space-xl);
  flex-wrap: wrap;
}

.padWrap {
  display: flex;
  flex-direction: column;
  gap: var(--token-space-xs);
  align-items: center;
}

.label {
  font-family: var(--token-font-ui);
  font-weight: 600;
}
